<!-- My Tickets -->
<section class="myTickets">
  <div class="title-wrapper">
    <h4 class="title-text text-primary">{{ "My Weapons" | translate }}</h4>
    <div class="title-actionWrapper">

      <button
        class="btn btn-light title-action"
        routerLink="/weapons/new-weapon"
      >
        <i class="fas fa-plus mr-3 text-primary align-middle"></i>
        <span>{{ "Add New Weapon" | translate }}</span>
      </button>
    </div>

  </div>
  <div class="row" *ngIf="weapons && weapons.length > 0; else noData">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table table-default invitations-table">
          <thead class="table-header text-center">
          <tr>
            <th scope="col">
              {{ "Weapon Number" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon Brand" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon Caliber" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon Type" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon License Type" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon License Expiry At" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon Created At" | translate }}
            </th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr class="text-center" *ngFor="let weapon of weapons; let i = index">

            <td scope="col"><a [href]="['/weapons/update-weapon/' + weapon.id]">{{ weapon.weaponNumber }}</a></td>
            <td scope="col">{{ weapon?.brand }}</td>
            <td scope="col">{{ weapon?.caliber }}</td>
            <td scope="col">{{ weapon?.weaponType | translate }}</td>
            <td scope="col" >{{ weapon?.licenseType | translate }}</td>
            <td scope="col" style="text-align: -webkit-center">
              <div
                class="status-box"
                [ngClass]="{
                      'bg-success':
                        formatDate(weapon.licenseExpiryAt, 'dd/MM/yyyy', 'en') > currentDate,
                      'bg-warning':
                        formatDate(weapon.licenseExpiryAt, 'dd/MM/yyyy', 'en') === currentDate,
                      'bg-danger': formatDate(weapon.licenseExpiryAt, 'dd/MM/yyyy', 'en') < currentDate,
                    }"
              >
                {{ weapon?.licenseExpiryAt | date : "dd/MM/yyyy" }}
              </div>
            </td>
            <td scope="col">
              {{ weapon?.createdAt | date : "dd/MM/yyyy" }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <app-pagination
    *ngIf="meta"
    [meta]="meta"
    (goPage)="goToPage($event)"
    (goNext)="onNext()"
    (goPrev)="onPrev()"
  >
  </app-pagination>
</section>

<ng-template #noData>
  <app-nodata
    title="{{ 'No Weapons Added' | translate }}"
    desc="{{ 'No Weapons Registered to Your Account' | translate }}"
    [img]="'assets/images/tickets/no-ticket.png'"
    link=""
  ></app-nodata>
</ng-template>

<ng-template #loading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-3x"></i>
  </div>
</ng-template>
